import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "cancel-afterSales" }
const _hoisted_3 = { class: "footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { toRaw } from 'vue'
import { afterSalesHandling } from '@/apis/order'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  rowItem: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props


const submit = () => {
  const {
    abnormalOrderId,
    afterSalesImg,
    afterSalesReason,
    afterSalesRefundTotalAmount,
    applyAfterSalesQuantity,
    detailedExplain,
    platformOrderNo,
    shopProductSku
  } = toRaw(props.rowItem)
  afterSalesHandling({
    abnormalOrderId,
    afterSalesImg,
    afterSalesReason,
    afterSalesRefundTotalAmount,
    applyAfterSalesQuantity,
    detailedExplain,
    afterSalesProgress: 6,
    platformOrderNo,
    shopProductSkus: [shopProductSku]
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('撤销成功'))
      emits('update:visible', false)
      emits('success')
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "cancel-afterSales-diaglog",
    "model-value": __props.visible,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('update:visible', false))),
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('该操作，会将已发起售后商品信息撤销，请确认是否撤销该商品售后？')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})